(function ($) {
    $.ns('Notifications');

    Notifications.Controller = function () {
        var _poller       = null,
            _service      = new Cortado.ServiceProxy(),
            _attempts     = 0,
            _pollDuration = 10000,
            _parameters = new ServiceParameters(),
            _skipIM = false,
            _promise = null;
            

        var handlers = {
            TopSpot: function (model) {
                $('#topspot-dash').msg('onMessageRecieved', model);
            },
            IM: function (model) {
                if (model.Count > 0 && Match.Chat.PollManager.enabled() === true) {
                    $('#globalChatAlertList').msg('refresh');
                }
            }
        }; 

        function ServiceParameters() {
            return {
                url  : '/alert/GetAllAlerts/',
                data : {}
            };
        };

        var getNotifications = function (publish) {
            _promise = new Cortado.Promise();

            if (_attempts >= 3) {
                _promise.reject({ "HttpStatusCode": 408 });
                self.Poller.Stop();
                return _promise;
            };

            _service.invoke(_parameters).then(
                function (response) {
                    // Stop polling on session timeout
                    if (response.StatusCode === 401) {
                        self.Poller.Stop();
                        _promise.reject({ "HttpStatusCode": response.StatusCode });
                        return _promise;
                    }

                    // Update endpoint after initial request.
                    _parameters.url = '/alert/TopSpotPoller/';
                    _parameters.data.lastImpressionDt = new Date().getTime();
                    _parameters.data.skipIM = _skipIM;

                    if (_parameters.data.pollCt >= 0) {
                        _parameters.data.pollCt++;
                    } else {
                        _parameters.data.pollCt = 0;
                    }


                    
                    if (publish) {
                        notify(response.Notifications);
                    }

                    _attempts = 0;
                    _promise.resolve(response.Notifications);
                },
                function (response) {
                    _attempts++;
                    console.log('Failed to return notifications. Attempts ' + _attempts + '. Reason : ' + response.statusText);

                    _promise.reject({ "HttpStatusCode": 408 });
                }
            );
            return _promise;
        };

        var notify = function (notifications) {
            for (var notification in notifications) {
                if (handlers.hasOwnProperty(notification)) {
                    handlers[notification](notifications[notification]);
                }
            }
        };

        var poll = function () {
            if (_poller === null) {
                _poller = setInterval(function () {
                    getNotifications(true);
                }, _pollDuration);
            }
        };

        var self = {
            Poller: {
                Status: _poller,
                Stop: function () {
                    _service.abort();
                    if (_promise)
                        _promise.reject({ "HttpStatusCode": 409 });
                    _service = new Cortado.ServiceProxy();
                    if (_poller)
                        clearInterval(_poller);
                    _poller = null;

                    return self;
                },

                Start: function (skipIm, topspotOn) {
                    _skipIM = skipIm;
                    if (topspotOn) {
                        getNotifications(true)
                            .then(function() {
                                poll();
                            });
                    }
                },

                Resume: function () {
                    poll();
                },

                Timeout: _pollDuration
            },

            GetAllNotifications: function (type, callback) {
                // Set last impression date to 20 sceonds into the future. 
                // Testing to see if this resolves race condition after successful purchase
                var dateNow = new Date();
                dateNow.setSeconds(dateNow.getSeconds() + 20);
                
                _attempts = 0;
                _parameters.data.lastImpressionDt = dateNow.toISOString();

                getNotifications(false).then(function(response) {
                    var notifications = response;

                    if (type && notifications.hasOwnProperty(type)) {
                        notifications = response[type];
                    }

                    if (callback) {
                        callback(notifications);
                    }
                });
            }
        };

        return self;
    }();

    $(document).ready(function () {
        var cuid = document.getElementById('cuid');
        var skipIm = false, topspotOn = false;
        if (document.getElementById('rtnLongPoll')) {
            skipIm = true;
        }
        if (document.getElementById('topspotActive')) {
            topspotOn = true;
        }
        if (cuid !== null) {
            var isLoggedIn = cuid.value !== '0';

            if (isLoggedIn) {
                Notifications.Controller.Poller.Start(skipIm, topspotOn);
            }
        }
    });
})(jQuery);